module.exports = __webpack_public_path__ + "3677b03560313366b6ca7058a528031c.svg";